import { Marker, Popup } from 'react-map-gl/mapbox';
import './SoilSensorMarker.css';
import { useMap } from 'react-map-gl/mapbox';
import CoordinatesLink from '../Base/CoordinatesLink';

import watermarkIcon from '../../../assets/soil-sensor-gota.png'; // Asegúrate de que la ruta sea correcta
import clockIcon from '../../../assets/clock.png';

const SoilSensorMarker = ({ data , isActive , onActivate , onDeactivate }) => {
  const { current: map } = useMap();
  return (
  <>
    <Marker 
      longitude={data.location.longitude} latitude={data.location.latitude}
      className="soil-sensor-marker"
      >
      <img
        onClick={(e) => {
          e.stopPropagation();
          map.easeTo({
                            center: [data.location.longitude, data.location.latitude],
                            offset: [0, -100], // desplaza el mapa hacia arriba
                            duration: 500,
                        });
          onActivate(); }} // Abre el popup al hacer clic
        src={watermarkIcon} alt="Soil Sensor" className='soil-sensor-marker-image' />
    </Marker>
    {isActive && (
        <Popup
            longitude={data.location.longitude}
            latitude={data.location.latitude}
            onClose={onDeactivate}
            closeOnClick={true}
            anchor="top"
        >
          <div style={{ fontFamily: "'Inter', sans-serif", maxWidth: '200px', minWidth: '150px' }} >
            <h3 style={{ marginBottom: '4px', fontSize: '14px' }}>Sensor Suelo</h3>
            <img src={watermarkIcon} alt="Watermark Soil Sensor" style={{ height: '60px', marginBottom: '10px' , float: 'right', marginRight: '10px' }} />
            <span style={{ fontSize: '28px' }}>{data.location.name}</span>
            <div style={{ marginTop: '8px' }}>
              <p title="Temperatura del suelo registrada por el sensor">
                  <span style={{fontSize: '30px', fontWeight: 'bold'}}>{data.lastObservation.soilTemperature ? <>{data.lastObservation.soilTemperature}</> : 'N/A'}</span> ºC</p>
              <p title="Humedad del suelo registrada por el sensor">
                  <span style={{fontSize: '30px', fontWeight: 'bold'}}>{data.lastObservation.soilHumidityCB ? <>{data.lastObservation.soilHumidityCB}</> : 'N/A'}</span> cB</p>
              <p title="Temperatura del aire registrada por el sensor"> 
                  <span style={{fontSize: '30px', fontWeight: 'bold'}}>{data.lastObservation.airTemperature ? <>{data.lastObservation.airTemperature}</> : 'N/A'}</span> ºC aire</p>
              <p title="Humedad del aire registrada por el sensor"> 
                  <span style={{fontSize: '30px', fontWeight: 'bold'}}>{data.lastObservation.airHumidity ? <>{data.lastObservation.airHumidity}</> : 'N/A'}</span> % aire</p>
            </div>
            <CoordinatesLink latitude={data.location.latitude} longitude={data.location.longitude} />
            <p style={{ display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
                <img src={clockIcon} alt='clock' style={{ height: '15px', width: '15px'}}/> {new Date(data.lastObservation.timestamp).toLocaleString('es-ES')}
            </p>
          </div>
        </Popup>
    )}
  </>
)};

export default SoilSensorMarker;